import React from 'react';
import MetricCard from './MetricCard';
import { toDataUri } from '../../utils/imageUtils';

function NoseAnalysisResults({ results, loading, error }) {
  const overlayImage = results ? toDataUri(results.overlayImage) : null;
  const heatmapImage = results ? toDataUri(results.heatmapImage) : null;

  if (loading) {
    return (
      <div className="nose-analysis-inline-loading">
        <div className="spinner" />
        <p>Calculating nose analysis metrics…</p>
      </div>
    );
  }

  if (error) {
    return <div className="status-banner status-banner-error">{error}</div>;
  }

  if (!results) return null;

  return (
    <>
      <div className="metrics-grid">
        <MetricCard label="Nose Width Before" value={results.noseWidthBefore} unit="mm" />
        <MetricCard label="Nose Width After" value={results.noseWidthAfter} unit="mm" />
        <MetricCard label="Tip Projection Before" value={results.tipProjectionBefore} unit="mm" />
        <MetricCard label="Tip Projection After" value={results.tipProjectionAfter} unit="mm" />
        <MetricCard label="Dorsal Hump Reduction" value={results.dorsalHumpReduction} unit="mm" highlight />
        <MetricCard label="Symmetry Improvement" value={results.symmetryImprovement} unit="%" highlight />
      </div>

      {(overlayImage || heatmapImage) && (
        <div className="visualization-grid" style={{ marginTop: '1.25rem' }}>
          {overlayImage && (
            <div className="visualization-card">
              <div className="visualization-card-header">Overlay Image</div>
              <div className="visualization-card-body">
                <img src={overlayImage} alt="Nose overlay analysis" />
              </div>
            </div>
          )}
          {heatmapImage && (
            <div className="visualization-card">
              <div className="visualization-card-header">Heatmap Image</div>
              <div className="visualization-card-body">
                <img src={heatmapImage} alt="Nose heatmap analysis" />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default NoseAnalysisResults;
